import BrandsHealthMindShareDashboard from "~/ui-rtk/components/features/dashboards/BrandHealthMindShareDashboard/BrandHealthMindShareDashboard"
import useConnect from "./connect"
import WithLoader from "~/ui-rtk/components/layout/WithLoader/WithLoader"
import useReconnectSourcesBanner from "~/ui-rtk/hooks/reconnect-sources-banner"
import { useEffect } from "react"
import ReconnectBanner from "~/ui-rtk/components/layout/ReconnectBanner/ReconnectBanner"
import SosTrendInsights from "./components/SosTrendInsights"
import SosReportDialogs from "./components/SosReportDialogs"

export default function BrandsHealthMindShare() {
  const { content, isLoading, requiredSources } = useConnect()

  const { connectorsToReconnect, setRequiredSources } =
    useReconnectSourcesBanner()

  useEffect(() => {
    setRequiredSources(requiredSources)
  }, [requiredSources])

  return (
    <WithLoader isLoading={isLoading}>
      <ReconnectBanner connectors={connectorsToReconnect} />
      <SosReportDialogs />
      <SosTrendInsights />
      <BrandsHealthMindShareDashboard
        slug={content.slug}
        charts={content.content.charts}
        title={content.content.title}
        parent={content.parent}
      />
    </WithLoader>
  )
}
